export enum ProposalType {
    BID = "BID",
    SOLE_SOURCE = "SOLE_SOURCE"
}
